"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * The is essentially an enum represents the type of the node
 * https://developer.mozilla.org/en-US/docs/Web/API/Node/nodeType
 * Values not listed here are deprecated.
 */
var NodeType;
(function (NodeType) {
    /**
     * An Element node such as &lt;p&gt; or &lt;div&gt;.
     */
    NodeType[NodeType["Element"] = 1] = "Element";
    /**
     * The actual Text of Element or Attr.
     */
    NodeType[NodeType["Text"] = 3] = "Text";
    /**
     * A ProcessingInstruction of an XML document such as &lt;?xml-stylesheet ... ?&gt; declaration.
     */
    NodeType[NodeType["ProcessingInstruction"] = 7] = "ProcessingInstruction";
    /**
     * A Comment node.
     */
    NodeType[NodeType["Comment"] = 8] = "Comment";
    /**
     * A Document node.
     */
    NodeType[NodeType["Document"] = 9] = "Document";
    /**
     * A DocumentType node e.g. &lt;!DOCTYPE html&gt; for HTML5 documents.
     */
    NodeType[NodeType["DocumentType"] = 10] = "DocumentType";
    /**
     * A DocumentFragment node.
     */
    NodeType[NodeType["DocumentFragment"] = 11] = "DocumentFragment";
})(NodeType = exports.NodeType || (exports.NodeType = {}));
//# sourceMappingURL=NodeType.js.map